import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from './baseQuery';

type ChampionApplicationInput = {
  firstName: string; //Must be between 2 and 50 characters
  lastName: string; //Must be between 2 and 50 characters
  applicationEmail: string; //Must be a valid email that hasn't already been used for an application
  title: string; //Must be between 2 and 50 characters
  bio: string; //Must be between 10 and 500 characters
  linkedIn: string; //Must be a valid URL
};

export const championApi = createApi({
  reducerPath: 'championApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    championApplication: builder.mutation<void, ChampionApplicationInput>({
      query: (input) => ({
        url: '/champion/application',
        method: 'POST',
        body: input,
      }),
    }),
  }),
});

export const { useChampionApplicationMutation } = championApi;
